import { useEffect, useState } from "react";

import { updateTaxSettings } from "../../services/settingsApi";

function TaxSettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        gstPercentage: "",
        platformTax: "",
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                gstPercentage: settings.gstPercentage || "",
                platformTax: settings.platformTax || "",
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateTaxSettings(formData);

            alert("Tax settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update tax settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Tax Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>GST Percentage (%)</label>

                        <input
                            type="number"
                            name="gstPercentage"
                            value={formData.gstPercentage}
                            onChange={handleChange}
                            min="0"
                            max="100"
                        />

                    </div>

                    <div className="form-group">

                        <label>Platform Tax (%)</label>

                        <input
                            type="number"
                            name="platformTax"
                            value={formData.platformTax}
                            onChange={handleChange}
                            min="0"
                            max="100"
                        />

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Tax Settings
                </button>

            </div>

        </form>

    );

}

export default TaxSettings;